import { dispatchTrackingEventGA4 } from 'common/tracking/dispatchTrackingEventGA4';
import { Element } from 'common/types/tracking';

const enum Event {
  GlobalHeaderClick = 'global-header-side-nav_click',
  ShopInShopClick = 'shop-in-shop-side-nav_click',
  SideNavTabsView = 'side-nav-tabs_view',
  SideNavTabsClick = 'side-nav-tabs_click',
}

const enum Interaction {
  Open = 'open',
  ChangeLanguage = 'change language',
}

export const enum SideNavPlacement {
  Primary = 'primary',
  Secondary = 'secondary',
  Courtesy = 'courtesy',
}

const home24ShopName = 'home24';

interface TrackNavigationClickOptions {
  element: Element;
  label: string;
  position: number;
  length: number;
  placement: SideNavPlacement;
  navLevel?: number;
  shopName?: string;
  navItemParent?: string;
  tabName?: string;
}

const getEventName = (shopName: string) =>
  shopName === home24ShopName ? Event.GlobalHeaderClick : Event.ShopInShopClick;

export const trackNavigationClick = ({
  element,
  label,
  position,
  length,
  placement = SideNavPlacement.Primary,
  navLevel,
  shopName = home24ShopName,
  navItemParent,
  tabName,
}: TrackNavigationClickOptions) => {
  dispatchTrackingEventGA4({
    event: getEventName(shopName),
    element,
    clicked_text: label,
    placement,
    list_position: position,
    list_length: length,
    ...(typeof navLevel === 'number' && { nav_level: `L${navLevel + 1}` }),
    shop_name: shopName,
    parent_category: navItemParent,
    ...(tabName && { tab_name: tabName }),
  });
};

const commonLanguageEventOptions = {
  event: Event.GlobalHeaderClick,
  element: Element.Dropdown,
  placement: SideNavPlacement.Courtesy,
  shop_name: home24ShopName,
};

export const trackLanguageClick = () => {
  dispatchTrackingEventGA4({
    ...commonLanguageEventOptions,
    interaction: Interaction.Open,
  });
};

export const trackLanguageChange = (label: string) => {
  dispatchTrackingEventGA4({
    ...commonLanguageEventOptions,
    interaction: Interaction.ChangeLanguage,
    label,
  });
};

export const trackLogoClick = (shopName = home24ShopName) => {
  dispatchTrackingEventGA4({
    event: getEventName(shopName),
    element: Element.Image,
    clicked_text: 'brand-logo',
    shop_name: shopName,
  });
};

export const trackCloseButtonClick = (clicked_text: string, shopName = home24ShopName) => {
  dispatchTrackingEventGA4({
    event: getEventName(shopName),
    element: Element.Button,
    clicked_text,
    shop_name: shopName,
  });
};

export const trackPromoImageClick = (clicked_text: string) => {
  dispatchTrackingEventGA4({
    event: Event.GlobalHeaderClick,
    element: Element.Image,
    clicked_text,
    shop_name: home24ShopName,
  });
};

export const trackSideNavTabsView = (activeTab: string) => {
  dispatchTrackingEventGA4({
    event: Event.SideNavTabsView,
    active_tab: activeTab,
    shop_name: home24ShopName,
  });
};

export const trackSideNavTabClick = (tabLabel: string, position: number, length: number) => {
  dispatchTrackingEventGA4({
    event: Event.SideNavTabsClick,
    element: Element.Button,
    clicked_text: tabLabel,
    list_position: position,
    list_length: length,
    shop_name: home24ShopName,
  });
};
